import type { IconProps } from "./icon-types";

/**
 * 원 안 체크 — success/positive 상태 표시. `CheckIcon`(bare)의 원 두른 변형.
 * Toast success tone 등 status 표현에서 공용.
 */
export const CheckCircleIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <circle cx="8" cy="8" r="6" />
    <path d="M5.2 8.3l2 2 3.6-4.2" />
  </svg>
);
